import { Routes } from '@angular/router';
import { BlankComponent } from './layouts/blank/blank.component';
import { FullComponent } from './layouts/full/full.component';
import { NFCProfileCardComponent } from './pages/nfc-profile-card/nfc-profile-card.component';
import { AppPrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';
import {
  AppsOrPagesGuard,
  AuthRedirectGuard,
  CustomerExistsGuard,
} from './services/route.guards';

export const routes: Routes = [
  {
    path: '',
    canActivate: [AppsOrPagesGuard, CustomerExistsGuard],
    component: FullComponent,
    children: [
      {
        path: '',
        redirectTo: '/landing',
        pathMatch: 'full',
      },
      {
        path: 'home',
        loadChildren: () =>
          import('./pages/pages.routes').then((m) => m.PagesRoutes),
      },
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./pages/dashboard/dashboard.routes').then(
            (m) => m.DashboardRoutes,
          ),
      },
      {
        path: 'ui-components',
        loadChildren: () =>
          import('./pages/ui-components/ui-components.routes').then(
            (m) => m.UiComponentsRoutes,
          ),
      },
      {
        path: 'forms',
        loadChildren: () =>
          import('./pages/forms/forms.routes').then((m) => m.FormsRoutes),
      },
      {
        path: 'charts',
        loadChildren: () =>
          import('./pages/charts/charts.routes').then((m) => m.ChartsRoutes),
      },
      {
        path: '',
        loadChildren: () =>
          import('./pages/apps/apps.routes').then((m) => m.AppsRoutes),
      },
      {
        path: 'widgets',
        loadChildren: () =>
          import('./pages/widgets/widgets.routes').then((m) => m.WidgetsRoutes),
      },
      {
        path: 'tables',
        loadChildren: () =>
          import('./pages/tables/tables.routes').then((m) => m.TablesRoutes),
      },
      {
        path: 'datatable',
        loadChildren: () =>
          import('./pages/datatable/datatable.routes').then(
            (m) => m.DatatablesRoutes,
          ),
      },
      {
        path: 'affiliates',
        loadChildren: () =>
          import('./pages/apps/affiliates/affiliates.routes').then(
            (m) => m.AffiliatesRoutes,
          ),
      },
      {
        path: 'admin',
        loadChildren: () =>
          import('./pages/admin/admin.routes').then((m) => m.AdminRoutes),
      },
      {
        path: 'theme-pages',
        loadChildren: () =>
          import('./pages/theme-pages/theme-pages.routes').then(
            (m) => m.ThemePagesRoutes,
          ),
      },
    ],
  },
  {
    path: '',
    component: BlankComponent,
    children: [
      {
        path: 'authentication',
        loadChildren: () =>
          import('./pages/authentication/authentication.routes').then(
            (m) => m.AuthenticationRoutes,
          ),
        canActivate: [AuthRedirectGuard],
      },
      {
        path: 'landing',
        loadChildren: () =>
          import('./pages/theme-pages/landingpage/landingpage.routes').then(
            (m) => m.LandingPageRoutes,
          ),
        canActivate: [AuthRedirectGuard],
      },
      {
        path: 'fira-breakdown',
        loadChildren: () =>
          import(
            './pages/theme-pages/firaLandingpage/firaLandingpage.routes'
          ).then((m) => m.FiraLandingPageRoutes),
        canActivate: [AuthRedirectGuard],
      },
      {
        path: 'privacy-policy',
        component: AppPrivacyPolicyComponent,

        canActivate: [AuthRedirectGuard],
      },
      {
        path: 'kyc-onboarding',
        loadChildren: () =>
          import('./pages/kyc-onboarding/kyc-onboarding.routes').then(
            (m) => m.KycOnboardingRoutes,
          ),
        canActivate: [AppsOrPagesGuard, AuthRedirectGuard],
      },
      {
        path: 'notifications',
        loadChildren: () =>
          import('./pages/notifications/notification.routes').then(
            (m) => m.NotificationRoutes,
          ),
      },
      {
        path: 'contact-us',
        loadChildren: () =>
          import('./pages/contact-us/contact-us.routes').then(
            (m) => m.ContactPageRoutes,
          ),
      },
    ],
  },
  { path: 'nfc-card', component: NFCProfileCardComponent },
  {
    path: 'nfc-card/build-profile',
    loadComponent: () =>
      import(
        './pages/nfc-profile-card/steps/build-profile/build-profile.component'
      ).then((m) => m.BuildProfileComponent),
    canActivate: [AppsOrPagesGuard],
  },
  {
    path: 'nfc-card/choose-design',
    loadComponent: () =>
      import(
        './pages/nfc-profile-card/steps/choose-design/choose-design.component'
      ).then((m) => m.ChooseDesignComponent),
    canActivate: [AppsOrPagesGuard],
  },
  {
    path: 'nfc-card/print-pick',
    loadComponent: () =>
      import(
        './pages/nfc-profile-card/steps/print-pick/print-pick.component'
      ).then((m) => m.PrintPickComponent),
    canActivate: [AppsOrPagesGuard],
  },
  {
    path: 'nfc-card/view',
    loadComponent: () =>
      import(
        './pages/nfc-profile-card/steps/view-card/view-card.component'
      ).then((m) => m.ViewCardComponent),
    canActivate: [AppsOrPagesGuard],
  },
  {
    path: 'nfc-card/profile/:userId',
    loadComponent: () =>
      import('./pages/nfc-profile-card/steps/profile/profile.component').then(
        (m) => m.ProfileComponent,
      ),
  },
  {
    path: 'faq',
    loadComponent: () =>
      import('./pages/faq/faq.component').then((m) => m.AppFaqComponent),
  },
  {
    path: 'mmr',
    loadComponent: () =>
      import('./pages/mmr/mmr-page.component').then((m) => m.MmrPageComponent),
  },
  {
    path: '**',
    redirectTo: '/landing',
  },
];
